export default __webpack_public_path__ + "static/media/pic8.0eb294d1.jpg";